var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.packets && _vm.packets.length > 0)?_c(_setup.LLayerGroup,{attrs:{"layer-type":"overlay","name":_vm.name,"visible":true}},_vm._l((_vm.packets),function(packet){return _c(_setup.PacketMarker,{key:packet.packetId,attrs:{"packet":packet,"icon":_vm.icon}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }